/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Distribution, DistributionFromJSON, DistributionFromJSONTyped, DistributionToJSON } from './Distribution'

/**
 *
 * @export
 * @interface AccountInfoResponse
 */
export interface AccountInfoResponse {
  /**
   *
   * @type {number}
   * @memberof AccountInfoResponse
   */
  userId?: number
  /**
   *
   * @type {string}
   * @memberof AccountInfoResponse
   */
  address?: string
  /**
   *
   * @type {number}
   * @memberof AccountInfoResponse
   */
  referralId?: number
  /**
   *
   * @type {number}
   * @memberof AccountInfoResponse
   */
  referredBy?: number
  /**
   *
   * @type {Distribution}
   * @memberof AccountInfoResponse
   */
  distribution?: Distribution
}

export function AccountInfoResponseFromJSON(json: any): AccountInfoResponse {
  return AccountInfoResponseFromJSONTyped(json, false)
}

export function AccountInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountInfoResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userId: !exists(json, 'userId') ? undefined : json['userId'],
    address: !exists(json, 'address') ? undefined : json['address'],
    referralId: !exists(json, 'referralId') ? undefined : json['referralId'],
    referredBy: !exists(json, 'referredBy') ? undefined : json['referredBy'],
    distribution: !exists(json, 'distribution') ? undefined : DistributionFromJSON(json['distribution']),
  }
}

export function AccountInfoResponseToJSON(value?: AccountInfoResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userId: value.userId,
    address: value.address,
    referralId: value.referralId,
    referredBy: value.referredBy,
    distribution: DistributionToJSON(value.distribution),
  }
}
